'use strict';

bbw.filter.plural = function() {
    var nplurals = 3, plural = function(n) {
        return (n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    };
    return function(num) {
        num = parseInt(num);
        if (isNaN(num)) {
            num = 0;
        }
        if (arguments.length < nplurals + 1) {
            console.warn("Too few plural forms");
        }
        return ('' + arguments[1 + plural(num)]).replace(/%d/g, '' + num);
    }
};
